const userMessageBlock = {
    title:null,
    text:null,
    acceptText:null,
    closeText:null,
    status:null,   
};

export default userMessageBlock;